


const data= {
    college:null,
    access_token:'',
    su_number:'',
};

export default data
